import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '../i18n'; // 确保正确引入 i18n 实例

// 引入 Vuex 模块
// 公共信息
import common from './modules/common';
// 导航
import nav from './modules/nav';

// 动态加载语言文件的工具函数
const loadLanguageContent = (moduleName, lang) => {
  return import(`./modules/${moduleName}/locales/${lang}`).then(module => module.default);
};

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    nav,
  },
  actions: {
    // 动态加载所有模块的语言内容
    loadAllModulesContent({ dispatch, rootState }) {
      const currentLang = i18n.locale; // 从 i18n 实例中获取当前语言

      // 定义所有模块的名称
      const modules = [
        'common',
        'nav',
      ];

      // 遍历模块，动态加载语言内容
      modules.forEach(moduleName => {
        loadLanguageContent(moduleName, currentLang).then(content => {
          dispatch(`${moduleName}/setContent`, content); // 调用模块的 setContent 动作
        });
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js